if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.acc-btn').click(function(e){
        e.preventDefault();
        if($(this).hasClass('active')){
            $(this).removeClass("active");
            $(this).next().slideToggle();
        }else{
            $(".acc-btn").removeClass("active");
            $(".tab-content").slideUp();
            $(this).addClass('active');
            $(this).next().slideToggle();
        }
    });
    $('.images-slides').slick({
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        fade: true,
        accessibility: false,
        focusOnSelect: false,
        pauseOnHover:false
    });

    $(".slick-tabs").slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 5,
        prevArrow: ".arrows__prev",
        nextArrow: ".arrows__next",
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                slidesToShow: 1,
                arrows: true,
                fade: true,
                },
            },
        ],
    });
    $(".gallery-line__list").slick({
        arrows: true,
        dots: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        nextArrow: '.gallery-line__arrow-prev',
        prevArrow: '.gallery-line__arrow-next',
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

    /*$('.checkbox input[type=checkbox][data-key*="0"]').change(function() {
        $(this).parents('.checkbox').find('input[type=checkbox]').prop('checked', $(this).is(':checked'));
    });*/

    $( ".form-module__field.checkbox input" ).on( "change", function(){

        $( "input[ name='emailcc[]']" ).remove();

        $( ".form-module__field.checkbox input" ).each(function(){

            if( $( this ).is( ":checked" ) )

                switch( $( this ).val() ){

                    case "La Jolla Cove Hotel & Suites":
                        $( "#form_id-535" ).append( '<input type="hidden" value="casselin@lajollacove.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="amarie@lajollacove.com" name="emailcc[]">' );
                        break;
                    case "Blue Sea Beach Hotel":
                        $( "#form_id-535" ).append( '<input type="hidden" value="ggunver@blueseabeachhotel.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="cdieu@pacificahotels.com" name="emailcc[]">' );
                        break;
                    case "The Wayfarer DTLA":
                        $( "#form_id-535" ).append( '<input type="hidden" value="eanderson@wayfarerdtla.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="dvidales@wayfarerdtla.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="eanderson@wayfarerdtla.com" name="emailcc[]">' );
                        break;
                    case "Carlyle Inn":
                        $( "#form_id-535" ).append( '<input type="hidden" value="cdieu@pacificahotels.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="eburnette@carlyle-inn.com" name="emailcc[]">' );
                        break;
                    case "Inn at Venice Beach":
                        $( "#form_id-535" ).append( '<input type="hidden" value="cdieu@pacificahotels.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="moliva@innatvenicebeach.com" name="emailcc[]">' );
                        break;
                    case "The Kinney":
                        $( "#form_id-535" ).append( '<input type="hidden" value="cdieu@pacificahotels.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="dwaggoner@thekinneyvenicebeach.com" name="emailcc[]">' );
                        break;
                    case "Marina del Rey Hotel":
                        $( "#form_id-535" ).append( '<input type="hidden" value="mwilliams@marinadelreyhotel.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="okahf@marinadelreyhotel.com" name="emailcc[]">' );
                        break;
                    case "Hotel Hermosa":
                        $( "#form_id-535" ).append( '<input type="hidden" value="cdieu@pacificahotels.com" name="emailcc[]">' );
                        break;
                    case "Jamaica Bay Inn, Tapestry Collection by Hilton":
                        $( "#form_id-535" ).append( '<input type="hidden" value="cgraves@jamaicabayinn.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="cmatsumoto@jamaicabayinn.com" name="emailcc[]">' );
                        break;
                    case "The Belamar Hotel, Tapestry Collection by Hilton":
                        $( "#form_id-535" ).append( '<input type="hidden" value="aharris@thebelamar.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="cdieu@pacificahotels.com" name="emailcc[]">' );
                        break;
                    case "Redondo Beach Hotel, Tapestry Collection by Hilton":
                        $( "#form_id-535" ).append( '<input type="hidden" value="asnow@theredondo.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="mcameron@theredondo.com" name="emailcc[]">' );
                        break;
                    case "Quality Inn & Suites Hermosa":
                        $( "#form_id-535" ).append( '<input type="hidden" value="cdieu@pacificahotels.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="afulton@hermosabeachinn.com" name="emailcc[]">' );
                        break;
                    case "Golden Sails":
                        $( "#form_id-535" ).append( '<input type="hidden" value="varreguin@goldensailshotel.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="snichols@goldensailshotel.com" name="emailcc[]">' );
                        break;
                    case "Pacifica Suites":
                        $( "#form_id-535" ).append( '<input type="hidden" value="jcross@pacificasuites.com" name="emailcc[]">' );
                        break;
                    case "Hotel Indigo Santa Barbara":
                        $( "#form_id-535" ).append( '<input type="hidden" value="lmendoza@indigosantabarbara.com" name="emailcc[]">' );
                        break;
                    case "Holiday Inn Express Santa Barbara":
                        $( "#form_id-535" ).append( '<input type="hidden" value="fromo@santabarbarahiex.com" name="emailcc[]">' );
                        break;
                    case "Spyglass Inn":
                        $( "#form_id-535" ).append( '<input type="hidden" value="cmorgan@spyglassinn.com" name="emailcc[]">' );
                        break;
                    case "Cottage Inn":
                        $( "#form_id-535" ).append( '<input type="hidden" value="shanson@pacificahotels.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="kstearns@cottage-inn.com" name="emailcc[]">' );
                        break;
                    case "The Tides":
                        $( "#form_id-535" ).append( '<input type="hidden" value="shanson@pacificahotels.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="dkregar@tidespismobeach.com" name="emailcc[]">' );
                        break;
                    case "Inn at The Pier":
                        $( "#form_id-535" ).append( '<input type="hidden" value="kpalera@theinnatthepier.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="mpalmer@pacificahotels.com" name="emailcc[]">' );
                        break;
                    case "La Jolla Cove Hotel & Suites":
                        $( "#form_id-535" ).append( '<input type="hidden" value="casselin@lajollacove.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="amarie@lajollacove.com" name="emailcc[]">' );
                        break;
                    case "Sandcastle Hotel on the Beach":
                        $( "#form_id-535" ).append( '<input type="hidden" value="shanson@pacificahotels.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="jdavison@sandcastlehotelonthebeach.com" name="emailcc[]">' );
                        break;
                    case "The Kinney SLO, Tapestry Collection by Hilton":
                        $( "#form_id-535" ).append( '<input type="hidden" value="jdawson@pacificahotels.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="mtaylor@thekinneyslo.com" name="emailcc[]">' );
                        break;
                    case "Oceanpoint Ranch":
                        $( "#form_id-535" ).append( '<input type="hidden" value="proberts@oceanpointranch.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="ksalloway@oceanpointranch.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="proberts@oceanpointranch.com" name="emailcc[]">' );
                        break;
                    case "Fireside Inn on Moonstone Beach":
                        $( "#form_id-535" ).append( '<input type="hidden" value="shanson@pacificahotels.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="jpaulino@fogcatcherinn.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="jpaulino@cambrialandinginn.com" name="emailcc[]">' );
                        break;
                    case "Cambria Landing Inn & Suites":
                        $( "#form_id-535" ).append( '<input type="hidden" value="shanson@pacificahotels.com" name="emailcc[]">' );
                        break;
                    case "FogCatcher Inn":
                        $( "#form_id-535" ).append( '<input type="hidden" value="shanson@pacificahotels.com" name="emailcc[]">' );
                        break;
                    case "Pelican Inn & Suites":
                        $( "#form_id-535" ).append( '<input type="hidden" value="shanson@pacificahotels.com" name="emailcc[]">' );
                        break;
                    case "El Colibri Hotel & Spa":
                        $( "#form_id-535" ).append( '<input type="hidden" value="shanson@pacificahotels.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="slukina@elcolibrihotel.com" name="emailcc[]">' );
                        break;
                    case "SpringHill Suites Paso Robles":
                        $( "#form_id-535" ).append( '<input type="hidden" value="ajones@springhillpasorobles.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="pharden@springhillpasorobles.com" name="emailcc[]">' );
                        break;
                    case "Half Moon Bay Lodge":
                        $( "#form_id-535" ).append( '<input type="hidden" value="kwesselmann@halfmoonbaylodge.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="lrehaut@halfmoonbaylodge.com" name="emailcc[]">' );
                        break;
                    case "Best Western Seacliff Inn":
                        $( "#form_id-535" ).append( '<input type="hidden" value="jramey@seacliffinn.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="ghicks@seacliffinn.com" name="emailcc[]">' );
                        break;
                    case "Courtyard King Kamehamehas Kona Beach Hotel":
                        $( "#form_id-535" ).append( '<input type="hidden" value="ccolvin@konabeachhotel.com" name="emailcc[]">' );
                        break;
                    case "Hilton Garden Inn Kauai Wailua Bay":
                        $( "#form_id-535" ).append( '<input type="hidden" value="sarah.cera@hilton.com" name="emailcc[]">' );
                        $( "#form_id-535" ).append( '<input type="hidden" value="ike.cockett@hilton.com" name="emailcc[]">' );
                        break;
                    case "Le Méridien Pasadena Arcadia ":
                        console.log( "asd" );
                        $( "#form_id-535" ).append( '<input type="hidden" value="tcanderle@lemeridienarcadia.com" name="emailcc[]">' );
                        break;

                }

        })

    } )

})();


function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 180;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start;

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration);
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration);
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer);

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

//placehorder for input date mobile
$("input[type=date],input[type=time]").on("input", function () {
    if ($(this).val().length > 0) {
        $(this).addClass("full");
    } else {
        $(this).removeClass("full");
    }
});


// Event Filter



if(document.getElementById("filter-quad-select")) {

    let filterButton = document.getElementById("filter-quad-select")
    let items = document.querySelectorAll(".filter-quad__item")

    showfirstItem(document.querySelectorAll(".filter-quad__item")[0])

    filterButton.addEventListener("change", function(){
        items.forEach(item => {
            if(item.classList.contains(filterButton.value)) {
                item.classList.remove("inactive")
            } else {
                item.classList.add("inactive")
            }
        })
    })
}

const video = document.querySelector("#video__topContent")
// pause or play the video
const play = (e) => {
    // Condition when to play a video
    if(video.paused){
        document.querySelector(".fa-play").style.display = "none"
        document.querySelector(".fa-pause").style.display = "block"
        video.play()
    }
    else{
        document.querySelector(".fa-play").style.display = "block"
        document.querySelector(".fa-pause").style.display = "none"
        video.pause()
    }
}

function showfirstItem(item){
    item.classList.remove("inactive")
}